import Vue from 'vue'
import Vuex from 'vuex'

import moment from 'moment'
import Session from '../model/Session'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        session: null,
        tokens: { list: [], updated: null },
        unmappedDomains: { list: [], updated: null }
    },
    mutations: {
        session (state, obj) {
            if (obj !== null && !(obj instanceof Session)) {
                throw new Error('No valid Session object to store.')
            }
            state.session = obj
        },

        tokens (state, tokenlist) {
            if (tokenlist instanceof Array) {
                state.tokens.list = tokenlist
                state.tokens.updated = moment().utc()
            }
        },

        unmappedDomains (state, list) {
            if (list instanceof Array) {
                state.unmappedDomains.list = list
                state.unmappedDomains.updated = moment().utc()
            }
        }
    },
    actions: {
    },
    modules: {
    }
})
